export const COUNTERS = [
    {
        count: 3,
        text: "Years<br />of Experience"
    },
    {
        count: 128,
        text: "Projects<br />Completed"
    }
]
